import React, { FC } from "react";
import { Button, Theme } from "@material-ui/core";
import { BUTTONS } from "../../constants";
import { makeStyles } from "@material-ui/styles";
import { Launch } from "@material-ui/icons";

const useStyles = makeStyles((theme: Theme) => ({
  anchor: {
    textDecoration: "none",
  },
  button: {
    margin: theme.spacing(1),
  },
}));

type ClinicalDataProps = {
  brandName: string;
};

const ClinicalData: FC<ClinicalDataProps> = ({ brandName }) => {
  const classes = useStyles();

  return (
    <a
      href={`https://clinicaltrials.gov/ct2/results?intr=%22${brandName}%22`}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.anchor}
    >
      <Button variant="contained" size="small" className={classes.button} startIcon={<Launch />}>
        {BUTTONS.CLINICAL_DATA}
      </Button>
    </a>
  );
};

export default ClinicalData;
